var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 116,
    viewBox: "0 0 101 116"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 0,
    y: 0,
    width: 101,
    height: 116,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PIN",
    transform: "translate(-672 -220)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 672, 220)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M-1990,51h65l-32.5,29Zm0,0V0h65V51Z",
    transform: "translate(2008 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(701.407 254.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M54.279,3.573h4.314L56.437,0",
    transform: "translate(-24.715)",
    fill: "#f89a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M46.525,3.573h4.316L48.683,0",
    transform: "translate(-21.185)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M50.4,0,52.56,3.575,54.717,0",
    transform: "translate(-22.95 0)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M69.788,29.258H74.1l-2.158-3.574",
    transform: "translate(-31.777 -11.733)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M62.035,29.258H66.35l-2.158-3.574",
    transform: "translate(-28.339 -11.733)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M65.911,25.684h4.316l-2.158,3.573",
    transform: "translate(-30.058 -11.733)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M65.911,22.837h4.316l-2.158-3.573",
    transform: "translate(-30.058 -8.8)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M46.525,16.416h4.316l-2.158-3.573",
    transform: "translate(-21.185 -5.867)",
    fill: "#f89a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M38.771,16.416h4.316l-2.158-3.573",
    transform: "translate(-17.654 -5.867)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M42.648,12.843h4.315l-2.158,3.572",
    transform: "translate(-19.419 -5.867)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M42.648,9.995h4.315L44.806,6.421",
    transform: "translate(-19.419 -2.933)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M43.086,19.262H38.771l2.157,3.574",
    transform: "translate(-17.654 -8.799)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M50.839,19.262H46.525l2.158,3.574",
    transform: "translate(-21.185 -8.799)",
    fill: "#f89a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M46.963,22.837H42.647l2.158-3.573",
    transform: "translate(-19.419 -8.8)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M46.963,25.684H42.647l2.158,3.573",
    transform: "translate(-19.419 -11.733)",
    fill: "#f89a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M58.6,19.264H54.281l2.157,3.573",
    transform: "translate(-24.716 -8.8)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M66.349,19.264H62.035l2.157,3.573",
    transform: "translate(-28.339 -8.8)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M62.472,22.837H58.156l2.159-3.573",
    transform: "translate(-26.481 -8.8)",
    fill: "#f89a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M62.472,25.684H58.156l2.159,3.574",
    transform: "translate(-26.481 -11.733)",
    fill: "#f89a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M62.033,16.416h4.315l-2.158-3.573",
    transform: "translate(-28.338 -5.867)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M54.278,16.416h4.316l-2.158-3.573",
    transform: "translate(-24.715 -5.867)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M58.155,12.843h4.316l-2.158,3.572",
    transform: "translate(-26.48 -5.867)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M58.155,9.995h4.316L60.313,6.421",
    transform: "translate(-26.48 -2.933)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M50.839,6.421H46.523l2.158,3.574",
    transform: "translate(-21.184 -2.933)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M58.594,6.421H54.278l2.158,3.574",
    transform: "translate(-24.715 -2.933)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M54.717,9.995H50.4l2.158-3.574",
    transform: "translate(-22.95 -2.933)",
    fill: "#f58b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M54.717,12.843H50.4l2.158,3.573",
    transform: "translate(-22.95 -5.867)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M23.264,3.575h4.315L25.421,0",
    transform: "translate(-10.593 0)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M15.51,3.575h4.315L17.666,0",
    transform: "translate(-7.062 0)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M19.387,0l2.157,3.574L23.7,0",
    transform: "translate(-8.828 0)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M19.823,6.421H15.507l2.158,3.574",
    transform: "translate(-7.061 -2.933)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M27.578,6.421H23.262L25.42,9.995",
    transform: "translate(-10.592 -2.933)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M23.7,10H19.385l2.158-3.573",
    transform: "translate(-8.827 -2.934)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M23.7,12.843H19.385l2.158,3.573",
    transform: "translate(-8.827 -5.867)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M15.51,16.416h4.315l-2.159-3.573",
    transform: "translate(-7.062 -5.867)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M7.755,16.416h4.316L9.913,12.843",
    transform: "translate(-3.439 -5.867)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M11.633,12.843h4.314l-2.157,3.573",
    transform: "translate(-5.297 -5.867)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M11.633,10h4.314L13.791,6.423",
    transform: "translate(-5.297 -2.934)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M7.755,29.258h4.316L9.913,25.684",
    transform: "translate(-3.439 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M0,29.257H4.315L2.158,25.684",
    transform: "translate(0 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M3.877,25.684H8.193L6.035,29.258",
    transform: "translate(-1.719 -11.733)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M3.877,22.837H8.193L6.035,19.264",
    transform: "translate(-1.719 -8.8)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M12.071,19.264H7.755l2.158,3.573",
    transform: "translate(-3.439 -8.8)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M19.824,19.264H15.508l2.159,3.573",
    transform: "translate(-7.061 -8.8)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M15.947,22.837H11.632l2.158-3.573",
    transform: "translate(-5.297 -8.8)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M15.947,25.684H11.631l2.159,3.574",
    transform: "translate(-5.158 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M27.579,19.264H23.263l2.158,3.573",
    transform: "translate(-10.593 -8.8)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M35.332,19.264H31.017l2.158,3.573",
    transform: "translate(-14.123 -8.8)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M31.456,22.837H27.14L29.3,19.264",
    transform: "translate(-12.358 -8.8)",
    fill: "#f26f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M31.456,25.684H27.14L29.3,29.258",
    transform: "translate(-12.358 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M38.771,29.257h4.315l-2.158-3.573",
    transform: "translate(-17.654 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M31.018,29.257h4.314l-2.157-3.573",
    transform: "translate(-14.124 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M34.9,25.684H39.21l-2.158,3.573",
    transform: "translate(-15.889 -11.733)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M34.9,22.836H39.21l-2.158-3.574",
    transform: "translate(-15.889 -8.799)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M31.017,16.416h4.315l-2.158-3.573",
    transform: "translate(-14.123 -5.867)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M23.263,16.416h4.316l-2.158-3.573",
    transform: "translate(-10.593 -5.867)",
    fill: "#f05b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M27.14,12.843h4.316L29.3,16.416",
    transform: "translate(-12.358 -5.867)",
    fill: "#f47e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M27.14,10h4.316L29.3,6.423",
    transform: "translate(-12.358 -2.934)",
    fill: "#f26f31"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgPin as ReactComponent };